enum EmailImportance {
	Low = "Low",
	Normal = "Normal",
	High = "High"
}

export default EmailImportance;
